export default __webpack_public_path__ + "static/media/logo__technology__graphql.c88bf378.svg";